import Tablesort from "tablesort";

export default class TableHelper {
  constructor() {
    let _this = this;
    _this.tables = $(".vbw-o-table");
  }

  init() {
    const _this = this;
    if (_this.tables && _this.tables.length > 0) {
      _this.initSorting(_this.tables);
      _this.initPagination(_this.tables);
    }
  }

  initSorting(elements) {
    let _this = this;
    let sortedTables = elements.filter(function () {
      return typeof $(this).attr("data-enable-sorting") !== "undefined";
    });
    for (let i = 0; i < sortedTables.length; i++) {
      let table = elements[i];
      Tablesort(table);
      table.addEventListener("beforeSort", _this.hideAllRows);
      table.addEventListener("afterSort", _this.showPaginatedRows);
    }
  }

  initPagination(elements) {
    let _this = this;
    let paginatedTables = elements.filter(function () {
      return (
        typeof $(this).attr("data-pagination") !== "undefined" &&
        parseInt($(this).attr("data-pagination")) > 0
      );
    });
    for (let i = 0; i < paginatedTables.length; i++) {
      let table = $(elements[i]);

      let pagination = parseInt(table.attr("data-pagination"));
      let button = table.next(".vbw-button-see-more");
      button.removeClass("hidden");

      table.find("tr.vbw-o-table__row").slice(pagination).addClass("hidden");

      button.on("click", _this.seeMore);

      if (typeof table.attr("data-paged-rows") !== "undefined") {
        let newValue =
          parseInt(table.attr("data-paged-rows")) +
          parseInt(table.attr("data-pagination"));
        table.data("data-paged-rows", newValue);
      } else {
        table.attr(
          "data-paged-rows",
          table.find(".vbw-o-table__row:not(.hidden)").length,
        );
      }
    }
  }

  seeMore(event) {
    requestAnimationFrame(() => {
      setTimeout(() => {
        let table = $(event.currentTarget).prev(
          ".vbw-o-table[data-pagination]",
        );
        let pagination = parseInt(table.attr("data-pagination"));
        table
          .find("tr.vbw-o-table__row.hidden:lt(" + pagination + ")")
          .removeClass("hidden");
        let pagedRows = parseInt(table.attr("data-paged-rows"));
        table.attr("data-paged-rows", pagedRows + pagination);
        $(event.currentTarget).focusout();
        event.currentTarget.blur();
        event.preventDefault();
      }, 0);
    });
  }

  hideAllRows(e) {
    let table = $(e.currentTarget);
    table.find(".vbw-o-table__row").addClass("hidden");
  }

  showPaginatedRows(e) {
    let table = $(e.currentTarget);
    let pagedRows = table.attr("data-paged-rows");
    table
      .find("tr.vbw-o-table__row.hidden:lt(" + pagedRows + ")")
      .removeClass("hidden");
  }
}

(function () {
  let cleanNumber = function (i) {
      return i.replace(/[^\-?0-9.]/g, "");
    },
    compareNumber = function (a, b) {
      a = parseFloat(a);
      b = parseFloat(b);

      a = isNaN(a) ? 0 : a;
      b = isNaN(b) ? 0 : b;

      return a - b;
    };

  Tablesort.extend(
    "number",
    function (item) {
      return (
        item.match(/^[-+]?[£\x24Û¢´€]?\d+\s*([,.]\d{0,2})/) || // Prefixed currency
        item.match(/^[-+]?\d+\s*([,.]\d{0,2})?[£\x24Û¢´€]/) || // Suffixed currency
        item.match(/^[-+]?(\d)*-?([,.])?-?(\d)+([E,e][-+]\d+)?%?$/)
      ); // Number
    },
    function (a, b) {
      return compareNumber(cleanNumber(b), cleanNumber(a));
    },
  );
})();
